
export default function searchBar() {
    headerSearch() // Check if cookie is currently active

}


function headerSearch() {

    var searchButton = document.getElementsByClassName("header-search-icon")[0];
    var searchContainer = document.getElementsByClassName("search-panel")[0];


    if (searchButton) {
        searchButton.addEventListener("click", function (evt) {

            var container = document.getElementsByClassName("search-panel")[0];

            if (!container.classList.contains('active')) {
                container.classList.add('active');
                document.querySelector('.search-panel input').focus();
                evt.preventDefault();

                overlayClick();

            }

            else if (container.classList.contains('active')) {
                container.classList.remove('active');
                document.querySelector('.search-panel input').blur();
            }

        }, false);
    }


    var searchClose = document.getElementsByClassName("search-close")[0];

    if (searchClose) {
        searchClose.addEventListener("click", function () {

            var input = document.querySelector(".search-panel input");

            searchContainer.classList.remove('active');
            input.value = '';

        }, false);
    }


}

function overlayClick() {
    var searchPanel = document.querySelector(".search-panel");
    var container = document.querySelector(".search-panel .container");

    document.addEventListener('mouseup', function (e) {
        var input = document.querySelector(".search-panel input");
        if (!container.contains(e.target)) {
            searchPanel.classList.remove('active');
            input.value = '';
        }
    });
}
